<template>
    <div class="mobile-fixed-board" :class="{loading: !invoice?.sub_total}">
        <button @click="next" :disabled="!proceedable" class="btn custom-btn custom-btn--primary mobile-fixed-board__btn">
            {{nextButtonLabel}}
        </button>
        <div class="mobile-fixed-board__price mobile-fixed-board__price--off" v-if="invoice?.discount">
            <div class="mobile-fixed-board__price__original-price">
                <span class="mobile-fixed-board__price__money-figure">{{numberFormat(invoice?.sub_total)}}</span>
                <span class="mobile-fixed-board__price__badge badge rounded-pill">%{{invoice.discount_percentage}}</span>
            </div>
            <div class="mobile-fixed-board__price__off-price">
                <span class="mobile-fixed-board__price__money-figure">{{numberFormat(invoice.total)}}</span>
                <span class="mobile-fixed-board__price__monetary-unit">تومان</span>
            </div>
        </div>
    </div>
</template>

<script>
import loading from "../general/Loading.vue";

export default {
    name: "TotalingMobile",
    props: ["proceedable", "invoice", "step"],
    emits: ["next"],
    methods: {
        next() {
            this.$emit('next');
        }
    },
    computed: {
        loading() {
            return loading
        },
        nextButtonLabel() {
            return this.step === 'shipping' ? 'انتخاب شیوه پرداخت' : 'پرداخت و تکمیل خرید'
        }
    }
}
</script>

<style scoped>

</style>
